import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import FollowAuditIssuesWidget from '../../../widgets/auditWidgets/followAuditIssuesWidgets/FollowAuditIssuesWidget'
import { sessionGetItemObj, sessionGetItemStr } from '../../../utils/sessionHelpers'
import { getReportsAudit } from '../../../redux/actions/reportsAudit'

export default function FollowAuditIssues() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  // const { id } = sessionGetItemObj('auditInfo')
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getReportsAudit('', projectId)
      // console.log('res => ', response)
      setSchema(response.model)

      // setSchema(mockSchema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi isShowGoButton />

        <FollowAuditIssuesWidget schema={schema} />
        <br />
      </SidebarProposal>
    </div>
  )
}
